import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const LogoutPageUI = ({context, successMsg}) =>
  <React.Fragment>
    {
      (!context.session || !successMsg) &&
      <SpinnerComponentUI />
    }
    {
      context.session && successMsg &&
      <PublicPageSF context={context} className='pg_logout' centered={true}>
        <div className='g_text_center'>
          {successMsg}
        </div>
      </PublicPageSF>
    }
  </React.Fragment>

export default LogoutPageUI
